import { NgModule } from '@angular/core';
import { RolePermissionService } from './services/role-permission.service';
import { StorageService } from './services/storage.service';
import { BaseService } from './services/base.service';
import { RuleEngineService } from './services/ruleengine.service';
import { DownloadService } from './services/download.service';
// import { MacService } from './services/mac.service';
// import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { CacheInterceptor } from '../services/cache.interceptor';

@NgModule({
  declarations: [
  ],
  imports: [

  ],
  exports: [
  ],
  providers: [
    RolePermissionService,
    DownloadService,
    StorageService,
    BaseService,
    // MacService,
    RuleEngineService,
    // { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true }
  ],
  // entryComponents: [
  // ]
})
export class BaseSharedModule { }
